// myTRiBE calendar: one-off dates, weekly recurrences, and monthly-nth rules.
// Entries carrying minLevel are only visible at or above that tier.

export const CALENDAR = {
  months:[
    [
      2026,
      6
    ],
    [
      2026,
      7
    ],
    [
      2026,
      8
    ]
  ],
  singles:[
    {
      d:"2026-07-19",
      name:"Sunday Service · Chaos with Pastor Trestan",
      time:"10:30 AM",
      emoji:"⛪"
    },
    {
      d:"2026-07-26",
      name:"Guest Speaker · Pastor Daniel Villarreal (Grace Avenue)",
      time:"10:30 AM",
      emoji:"🎤"
    },
    {
      d:"2026-08-02",
      name:"Back to School Weekend · Two Services Launch",
      time:"9:30 & 11:30 AM",
      emoji:"🎒"
    },
    {
      d:"2026-08-26",
      name:"Pastor Courtney's Birthday",
      time:"All day",
      emoji:"🎂"
    },
    {
      d:"2026-09-11",
      name:"CLLXTV Music Drop — stream & download 'Praise The Lord'",
      time:"All platforms",
      emoji:"🎧"
    }
  ],
  weekly:[
    {
      weekday:0,
      start:"2026-08-09",
      name:"Sunday · Two Services",
      time:"9:30 & 11:30 AM",
      emoji:"⛪"
    },
    {
      weekday:1,
      start:"2026-07-20",
      name:"Strategy Team Zoom with Pastor Trestan",
      time:"7:00 PM",
      minLevel:"leader",
      tag:"Leaders & Directors",
      emoji:"🧭"
    },
    {
      weekday:4,
      start:"2026-07-23",
      name:"Rehearsal",
      time:"7:00 PM",
      minLevel:"leader",
      tag:"Worship · Band · Production",
      emoji:"🎛️"
    }
  ],
  monthlyNth:[
    {
      nth:2,
      weekday:2,
      name:"CLLXTV Prayer Night",
      time:"7:00 PM",
      emoji:"🙏"
    }
  ]
};
